import { render } from "./DefaultIntegrations.vue?vue&type=template&id=22843870"
import script from "./DefaultIntegrations.vue?vue&type=script&lang=js"
export * from "./DefaultIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__